<ng-template #restrictionAddEditModal let-c="close" let-d="dismiss">
    <form #restrictionAddEditForm="ngForm" [class.submitted]="restrictionAddEditForm.submitted" (ngSubmit)="submit(restrictionAddEditForm)" novalidate>
        <div class="modal-header">
            <div class="modal-title"><span class="bold">{{ editMode ? 'Edit' : 'Add new' }}</span> Trade Restriction</div>
            <button type="button" class="rms-sheet-close" aria-label="Close" (click)="c()">&times;</button>
        </div>
        <div class="modal-body">
            <div class="d-inline-flex w-100 rms-sheet-pair" style="gap: 20px;">
                <div class="form-group w-100">
                    <label for="restrictionCompany">{{ "GENERICS.COMPANY" | translate }}<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="companyRef" [componentForm]="restrictionAddEditForm"></rms-required-label>
                    </label>
                  <rms-autocomplete-select id="restrictionCompany" name="restrictionCompany" #companyRef="ngModel"
                                           [(ngModel)]="tradeRestriction.company"
                                           [autocompleteName]="'companies'"
                                           [entityType]="CompanyBasic"
                                           [showAllTenants]="true"
                                           [disabled]="editMode"
                                           [filterFn]="filterOutPrivateCompanies"
                                           [required]="true">
                  </rms-autocomplete-select>
                </div>

                <div class="form-group w-100">
                    <label for="restrictionPerson">Person<sup class="red">*</sup>
                      <rms-required-label [formFieldReference]="personRef" [componentForm]="restrictionAddEditForm"></rms-required-label>
                    </label>
                    <ng-select [(ngModel)]="tradeRestriction.person" [items]="people" [multiple]="false"
                               bindLabel="fullName" name="restrictionPerson" id="restrictionPerson" #personRef="ngModel" required>
                      <ng-template ng-option-tmp let-item="item">
                        {{ item.fullName }}<span *ngIf="!item.active" class="inactive-label"> (inactive)</span>
                      </ng-template>
                    </ng-select>
                </div>
            </div>

            <div class="d-inline-flex w-100 rms-sheet-pair" style="gap: 20px;">
                <div class="form-group w-100">
                    <label for="restrictionType">Trade Restriction Type<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="restrictionTypeRef" [componentForm]="restrictionAddEditForm"></rms-required-label>
                    </label>
                    <ng-select [(ngModel)]="tradeRestriction.reason" [items]="restrictionTypes" [disabled]="editMode"
                               name="restrictionType" id="restrictionType" #restrictionTypeRef="ngModel" required>
                        <ng-template ng-label-tmp let-item="item">{{ TradeRestrictionReasonLabels[item] }}</ng-template>
                        <ng-template ng-option-tmp let-item="item">{{ TradeRestrictionReasonLabels[item] }}</ng-template>
                    </ng-select>
                </div>

                <div class="form-group w-100">
                    <label for="restrictionLevel">Trade Restriction Level<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="restrictionLevelRef" [componentForm]="restrictionAddEditForm"></rms-required-label>
                    </label>
                    <ng-select [ngModel]="fixedReasonLevels.has(tradeRestriction.reason) ? fixedReasonLevels.get(tradeRestriction.reason) : tradeRestriction.level"
                               (ngModelChange)="tradeRestriction.level = $event"
                               [items]="restrictionLevels"
                               [disabled]="fixedReasonLevels.has(tradeRestriction.reason) || !tradeRestriction.active"
                               name="restrictionLevel" id="restrictionLevel" #restrictionLevelRef="ngModel" required>
                        <ng-template ng-label-tmp let-item="item">{{ TradeRestrictionLevelLabels[item] }}</ng-template>
                        <ng-template ng-option-tmp let-item="item">{{ TradeRestrictionLevelLabels[item] }}</ng-template>
                    </ng-select>
                </div>
            </div>

            <div class="d-inline-flex w-100 rms-sheet-pair" style="gap: 20px;">
                <div class="form-group w-100">
                    <label for="restrictionStartDate">Start Date<sup class="red">*</sup>
                        <rms-required-label [formFieldReference]="restrictionStartDateRef" [componentForm]="restrictionAddEditForm"></rms-required-label>
                    </label>
                    <div class="input-group">
                        <rms-date-picker id="restrictionStartDate"
                                         name="restrictionStartDate"
                                         #restrictionStartDateRef="ngModel"
                                         [(ngModel)]="startDate"
                                         [isRange]="false"
                                         required>
                        </rms-date-picker>
                    </div>
                </div>
            </div>

            <div *ngIf="editMode && !tradeRestriction.active" class="form-group w-100">
                <label for="restrictionEndDate">End Date</label>
                <div class="input-group">
                    <rms-date-picker id="restrictionEndDate"
                                    name="restrictionEndDate"
                                    #restrictionEndDateRef="ngModel"
                                    [(ngModel)]="endDate"
                                    [min]="startDate"
                                    [max]="maxEndDate"
                                    [required]="true"
                                    [isRange]="false">
                    </rms-date-picker>
                </div>
            </div>


            <div class="form-group">
                <label for="restrictionDetails">Details</label>
                <textarea id="restrictionDetails" name="restrictionDetails" class="form-control" [(ngModel)]="tradeRestriction.details" rows="2"></textarea>
            </div>
        </div>
        <div class="modal-footer">
          <div class="rms-sheet-eze" *ngIf="!environment.production">
            <input id="force-eze-error" name="force-eze-error" type="checkbox" [(ngModel)]="forceEzeError" />
            <label for="force-eze-error">Force Eze Error</label>
          </div>
          <button type="button" class="btn btn-outline-teal" (click)="c()">{{ "GENERICS.CANCEL" | translate }}</button>
          <button type="submit" class="btn btn-teal" [disabled]="restrictionAddEditForm.invalid">Submit</button>
        </div>
    </form>
</ng-template>
